<template>
    <q-card class="full-height bg-white">
        <q-card-title class="text-center bg-primary text-white">
            {{ $t('badges') }}
        </q-card-title>

        <q-card-separator />

        <q-card-main class="text-center relative-position full-height">
            <div class="row gutter-sm">
                <div class="badge" :class="home ? 'col-xs-4 col-sm-2' : 'col-xs-4 col-sm-1'" v-for="(badge, index) in badges" :key="index">
                    <img :src="getBadgeImage(badge)" :class="getBadgeClass(badge)" class="cursor-pointer" @click="showBadgeInfo(badge)" />
                </div>
            </div>

            <q-inner-loading :visible="!badges">
                <q-spinner-dots :size="60" color="secondary"></q-spinner-dots>
            </q-inner-loading>
        </q-card-main>

        <q-modal v-if="show_info" v-model="show_info" :content-css="{minWidth: getMinWidth, maxWidth: getMaxWidth}">
            <q-modal-layout>
                <q-toolbar slot="header">
                    <q-btn flat round dense @click="show_info = false" icon="fas fa-times" />
                    <q-toolbar-title>
                        {{ selected_badge.title }}
                    </q-toolbar-title>
                </q-toolbar>

                <div class="layout-padding">
                    <div class="row gutter-sm">
                        <div class="col-xs-12 col-sm-3 badge">
                            <img :src="getBadgeImage(selected_badge)" :class="getBadgeClass(selected_badge)" />
                        </div>
                        <div class="col-xs-12 col-sm-9">
                            <div class="q-display-1 q-mb-md">{{ selected_badge.title }}</div>
                            <p>{{ selected_badge.description }}</p>
                            <p v-if="selected_badge.earned_date">{{ $t('earned_in') }}: {{ formatDate(selected_badge.earned_date) }}</p>
                        </div>
                    </div>
                </div>
            </q-modal-layout>
        </q-modal>
    </q-card>
</template>

<script>
import { date } from 'quasar'
const { formatDate } = date
import { mapGetters } from 'vuex'

export default {
    i18nOptions: { namespaces: [ "custom", 'custom', 'common', 'profile'] },

    props: ['badges', 'home'],

    data() {
        return {
            selected_badge: [],
            show_info: false
        }
    },

    computed: {
        ...mapGetters({
            id_user_language_selected: 'common/id_user_language_selected',
        }),
        getMaxWidth() {
            if (this.$q.platform.is.mobile) return '100vw'
            else return '80vw'
        },

        getMinWidth() {
            if (!this.$q.platform.is.mobile) return '90vw'
        },
    },

    methods: {
        getBadgeImage(badge) {
            if (badge.badge_images.length > 0) {
                let obj = badge.badge_images.find((obj) => { return obj.image_name === '250x250' })
                if (obj) return obj.image
            }
            return ''
        },

        getBadgeClass(badge) {
            if (!badge.earned_date) return 'disable-badge'
        },

        showBadgeInfo(badge) {
            this.selected_badge = badge
            if(badge.badge_languages.length > 0) {
                badge.badge_languages.map(e => {
                    if(e.language == this.id_user_language_selected){
                        this.selected_badge.description = e.description
                        this.selected_badge.title = e.title
                    }
                })

                if(!this.selected_badge.description && !this.selected_badge.title) {
                    this.selected_badge.description = badge.badge_languages[0].description
                    this.selected_badge.title = badge.badge_languages[0].title
                }
            }
            this.show_info = true
        },

        formatDate(d) {
            return date.formatDate(d, 'DD/MM/YYYY HH:mm:ss')
        }
    }
}
</script>

<style lang="stylus" scoped>
.disable-badge
    filter grayscale(100%)
    &:hover
        filter inherit

.badge
    & img
        width 100%
        height auto
</style>
